// ============================================================================
// Incentive nav badge — the pure count (CW-Q 4.1).
//
// It lives in its own module so it can be unit-tested without a Supabase client.
// The rule it encodes is not arithmetic, it is a product invariant: the badge
// counts everything waiting on a HUMAN, across BOTH steps of the two-step model.
//
// The bug it fixes: the badge summed `pending_review_count` alone. CW-N split
// validation into step 1 (AM validates) and step 2 (approver approves). After
// that split, the moment the last AM validated the last row, `pending_review`
// hit zero, the badge hit zero, and Jack's approval queue vanished from the nav
// with real money sitting in it — waiting on him specifically, with nothing
// telling him so. A badge that goes quiet exactly when it becomes one person's
// turn is worse than no badge.
// ============================================================================

export interface NavBadgeCounts {
  pending_review_count: number | null;
  am_validated_count: number | null;
}

/**
 * Total payouts awaiting a human across the visible periods: step 1 plus step 2.
 * Tolerates nulls because the counts arrive from a view over LEFT JOIN LATERAL
 * aggregates, and a period with no rows at all yields nulls rather than zeros in
 * some PostgREST shapes.
 */
export function navBadgeCount(rows: readonly NavBadgeCounts[]): number {
  return rows.reduce(
    (sum, r) => sum + (r.pending_review_count ?? 0) + (r.am_validated_count ?? 0),
    0,
  );
}
